import {LoginModal, RedeemSectionData, GiftcardConfig} from '../../utils/types';
import React, {useCallback, useMemo} from 'react';
import {localizedMessage} from '../message/Message';
import PosaTemplate from './PosaTemplate';
import PropTypes from 'prop-types';
import RedeemSectionLoggedInStyled from './RedeemSectionLoggedInStyled';
import GiftcardBox from './GiftcardBox';

export interface Props {
  data: RedeemSectionData;
  getStartAction: (string) => void;
  loginModal: LoginModal;
  giftcardConfig: GiftcardConfig;
}

const UnLoggedInSection = ({data, getStartAction, loginModal, giftcardConfig}: Props) => {
  const {unLoggedInContent, bgImage, moneyImage} = data;
  const {warningContent} = loginModal;
  const {posaGiftCardCardShow, posaGiftCardRedeemUrl} = giftcardConfig;
  const style = useMemo(
    () => ({
      backgroundImage: `url(${bgImage})`,
    }),
    [bgImage]
  );
  const onClick = useCallback(() => getStartAction(warningContent), [warningContent]);

  return (
    <RedeemSectionLoggedInStyled className="ecr-redeemSection unloggedIn" style={style}>
      <div className="ecrrs-left">
        <img src={moneyImage} alt="card" />
      </div>
      <div className="ecrrs-right">
        <div className="ecrrs-notLoggedIn">
          <PosaTemplate Tag="div" isTemplate string={unLoggedInContent} />
          <button onClick={onClick}>
            {localizedMessage('epic.code.redemption.posa.page.start')}
          </button>
        </div>
        {posaGiftCardCardShow && (
          <GiftcardBox showDesc={true} posaGiftCardRedeemUrl={posaGiftCardRedeemUrl} />
        )}
      </div>
    </RedeemSectionLoggedInStyled>
  );
};

UnLoggedInSection.propTypes = {
  data: PropTypes.object,
  getStartAction: PropTypes.func,
  loginModal: PropTypes.object,
  giftcardConfig: PropTypes.object,
};

export default UnLoggedInSection;
